import React from 'react';
import UniversalAuthPage from '../../../components/Auth/UniversalAuthPage';

const AirlinerPasswordExpiredPage = () => {
  const handlePasswordExpired = async (formData) => {
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    // Simulate success
    alert('Password updated successfully! Please login with your new password.');
    // Navigation is handled by UniversalAuthPage
  };

  const customValidation = (formData, setErrors) => {
    const newErrors = {};

    if (!formData.currentPassword) {
      newErrors.currentPassword = 'Current password is required';
    }

    if (!formData.password) {
      newErrors.password = 'New password is required';
    } else if (formData.password.length < 11) {
      newErrors.password = 'Password must be at least 11 characters long';
    }

    if (!formData.passwordConfirmation) {
      newErrors.passwordConfirmation = 'Please confirm your new password';
    } else if (formData.password !== formData.passwordConfirmation) {
      newErrors.passwordConfirmation = 'Passwords do not match';
    }

    if (formData.currentPassword && formData.password && formData.currentPassword === formData.password) {
      newErrors.password = 'New password must be different from current password';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const additionalFields = [
    {
      label: 'Current Password',
      name: 'currentPassword',
      type: 'password',
      placeholder: 'Enter your current password',
      required: true,
      className: 'col-span-2'
    }
  ];

  return (
    <UniversalAuthPage
      type="password-expired"
      appType="airliner"
      title="Password Expired"
      subtitle="Your password has expired. Please create a new password to continue."
      onSubmit={handlePasswordExpired}
      additionalFields={additionalFields}
      showPasswordGenerator={true}
      customValidation={customValidation}
      redirectPaths={{
        success: '/airliner/auth/login'
      }}
      showExpiryWarning={true}
    />
  );
};

export default AirlinerPasswordExpiredPage;